<template>
    <section>
        <PageTitle title="Coming Soon" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'javascript:void(0)',title:'Coming Soon'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <h1>Coming Soon!</h1>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import PageTitle from "../components/layout_components/PageTitle";
    export default {
        name: "ComingSoon",
        components: {PageTitle}
    }
</script>

<style scoped>

</style>